import React from "react";
import { CustomDatepicker } from "tvs-unified-lib";

interface SimpleDatePickerProps {
  value?: string; // ISO date string or empty
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  minDate?: Date;
  showMonthYearPicker?: boolean;
  format?: string;
  label?: string;
  required: boolean;
}

const SimpleDatePicker: React.FC<SimpleDatePickerProps> = ({
  value,
  onChange,
  placeholder,
  disabled = false,
  minDate,
  showMonthYearPicker = false,
  format = "dd MMMM yyyy",
  label,
  required = false,
}) => {
  return (
    <CustomDatepicker
      onResetDate={() => {
        if (!disabled) onChange("");
      }}
      placeholder={placeholder}
      showMonthYearPicker={showMonthYearPicker}
      format={format}
      value={value ? new Date(value) : null}
      formLabel={label}
      isRequired={required}
      onInputChange={(val: any) => {
        if (!disabled) onChange(val);
      }}
      hasError={false}
      errorMessage={undefined}
      minDate={minDate}
      disabled={disabled}
    />
  );
};

export default SimpleDatePicker;
